module.exports = __webpack_public_path__ + "img/joinaspanelist.5a43662e.svg";